// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContactForm_wrapper__LUqVC","header":"ContactForm_header__G_snm","btn":"ContactForm_btn__vsB23","message":"ContactForm_message__6xp_3"};